import {
  AlertTriangle,
  AlignLeft,
  Columns2,
  FileText,
  Heading2,
  List,
  Minus,
  MessageSquareQuote,
  Image,
  Table,
  Type,
  Video,
  type LucideIcon,
} from 'lucide-react';
import type { SlideBlockType } from '@hcc/types';

/** Display metadata per block type, shared by the add menu and block cards. */
export const BLOCK_META: Record<
  SlideBlockType,
  { label: string; icon: LucideIcon; description: string }
> = {
  heading: { label: 'Heading', icon: Heading2, description: 'A section subheading' },
  text: { label: 'Text', icon: AlignLeft, description: 'A paragraph of body text' },
  list: { label: 'List', icon: List, description: 'A bullet or numbered list' },
  callout: { label: 'Callout', icon: AlertTriangle, description: 'A highlighted tip or warning' },
  image: { label: 'Image', icon: Image, description: 'A picture with optional caption' },
  pdf: { label: 'PDF', icon: FileText, description: 'Embed a PDF to read inline' },
  video: { label: 'Video', icon: Video, description: 'A video the learner must watch to continue' },
  quote: { label: 'Quote', icon: MessageSquareQuote, description: 'A quotation with attribution' },
  statement: { label: 'Big statement', icon: Type, description: 'A large centred line' },
  table: { label: 'Table', icon: Table, description: 'Rows and columns' },
  divider: { label: 'Divider', icon: Minus, description: 'A horizontal rule' },
  columns: { label: 'Two columns', icon: Columns2, description: 'Two side-by-side columns' },
};

/** Add-menu order; columns is excluded inside a column cell. */
export const BLOCK_ORDER: SlideBlockType[] = [
  'heading',
  'text',
  'list',
  'callout',
  'image',
  'pdf',
  'video',
  'quote',
  'statement',
  'table',
  'divider',
  'columns',
];

/** Grouping for the visual add-block menu. */
export const BLOCK_GROUPS: { title: string; types: SlideBlockType[] }[] = [
  { title: 'Text', types: ['heading', 'text', 'list', 'quote', 'statement'] },
  { title: 'Media', types: ['image', 'pdf', 'video'] },
  { title: 'Layout', types: ['callout', 'table', 'divider', 'columns'] },
];
